import React from "react"
import { FaBars } from "react-icons/fa"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import classes from "./OrderTopbar.module.scss"

const OrderTopbar = props => {
  const { setOpenOrderSidebar } = props

  const i18n = useTranslation()[1]

  const isLtr = i18n.dir(i18n.language) === "ltr"

  return (
    <div className={classes["container"]}>
      <button
        id="order-hamburger-button"
        onClick={() => setOpenOrderSidebar(prev => !prev)}
        className={clsx(
          classes["button"],
          isLtr && classes["button-ltr"]
        )}
      >
        <FaBars
          size={20}
          color="white"
        />
      </button>
    </div>
  )
}

export default OrderTopbar